/**************************** AUTH ************************************/

export const LOGIN = '/api/auth/login';


/**************************** USERS ***********************************/

export const CREATE_USER = '/api/users';
export const GET_ALL_USERS = '/api/users';
export const GET_USER_BY_ID = '/api/users/';
export const UPDATE_USER = '/api/users/';
export const UPDATE_USER_STATUS = '/api/users/';
export const UPDATE_USER_PASSWORD = '/api/users/';
export const DELETE_USER_BY_ID = '/api/users/';


/**************************** SETTINGS ********************************/

export const SETTINGS_CATEGORIES = '/api/settings/categories';
export const SETTINGS_PAYMENT_MODES = '/api/settings/payment-modes';
export const SETTINGS_SALE_CHANNELS = '/api/settings/sale-channels';
export const SETTINGS_COMPANY = '/api/settings/company';

/**************************** CATEGORIES ******************************/

export const GET_ALL_CATEGORIES = '/api/settings/categories';
export const GET_CATEGORY_BY_ID = '/api/settings/categories/';
export const CREATE_CATEGORY = '/api/settings/categories';
export const UPDATE_CATEGORY = '/api/settings/categories/';
export const UPDATE_CATEGORY_STATUS = '/api/settings/categories/';
export const DELETE_CATEGORY = '/api/settings/categories/';


/**************************** PAYMENT MODES ***************************/

export const GET_ALL_PAYMENT_MODES = '/api/settings/payment-modes';
export const GET_PAYMENT_MODE_BY_ID = '/api/settings/payment-modes/';
export const CREATE_PAYMENT_MODE = '/api/settings/payment-modes';
export const UPDATE_PAYMENT_MODE = '/api/settings/payment-modes/';
export const UPDATE_PAYMENT_MODE_STATUS = '/api/settings/payment-modes/';
export const DELETE_PAYMENT_MODE = '/api/settings/payment-modes/';


/**************************** SALE CHANNELS ***************************/

export const GET_ALL_SALE_CHANNELS = '/api/settings/sale-channels';
export const GET_SALE_CHANNEL_BY_ID = '/api/settings/sale-channels/';
export const CREATE_SALE_CHANNEL = '/api/settings/sale-channels';
export const UPDATE_SALE_CHANNEL = '/api/settings/sale-channels/';
export const UPDATE_SALE_CHANNEL_STATUS = '/api/settings/sale-channels/';
export const DELETE_SALE_CHANNEL = '/api/settings/sale-channels/';



/**************************** COMPANY SETTINGS ***********************/

export const GET_COMPANY_SETTINGS = '/api/settings/company';
export const UPDATE_COMPANY_SETTINGS = '/api/settings/company';
export const UPLOAD_COMPANY_LOGO = '/api/settings/company/logo';
export const GET_COMPANY_LOGO = '/api/settings/company/logo';
export const DELETE_COMPANY_LOGO = '/api/settings/company/logo';
export const GET_PUBLIC_COMPANY = '/api/public/company';
export const GET_PUBLIC_COMPANY_LOGO = '/api/public/company/logo';

/**************************** PRODUCTS *********************************/

export const GET_ALL_PRODUCTS = '/api/products';
export const GET_PRODUCT_BY_ID = '/api/products/';
export const CREATE_PRODUCT = '/api/products';
export const UPDATE_PRODUCT = '/api/products/';
export const ARCHIVE_PRODUCT = '/api/products/';
export const RESTORE_PRODUCT = '/api/products/';

/****************************** STOCKS *********************************/

export const GET_ALL_STOCK_MOVEMENTS = '/api/stock/movements';
export const GET_STOCK_MOVEMENTS_BY_PRODUCT = '/api/stock/movements/product/';
export const CREATE_STOCK_MOVEMENT = '/api/stock/movements';

/**************************** CLIENTS *********************************/

export const GET_ALL_CLIENTS = '/api/clients';
export const GET_CLIENT_BY_ID = '/api/clients/';
export const CREATE_CLIENT = '/api/clients';
export const UPDATE_CLIENT = '/api/clients/';


/**************************** SALES ***********************************/

export const GET_ALL_SALES = '/api/sales';
export const GET_SALE_BY_ID = '/api/sales/';
export const CREATE_SALE = '/api/sales';
export const CANCEL_SALE = '/api/sales/';

/**************************** EXPENSES ********************************/

export const GET_ALL_EXPENSES = '/api/expenses';
export const CREATE_EXPENSE = '/api/expenses';
export const DELETE_EXPENSE = '/api/expenses/';


/**************************** CASH ENTRIES ****************************/

export const GET_ALL_CASH_ENTRIES = '/api/cash-entries';
export const GET_CASH_ENTRY_BY_ID = '/api/cash-entries/';
export const CREATE_CASH_ENTRY = '/api/cash-entries';
export const DELETE_CASH_ENTRY = '/api/cash-entries/';


/**************************** OBJECTIVES ********************************/

export const GET_ALL_OBJECTIVES = '/api/objectives';
export const GET_OBJECTIVE_BY_ID = '/api/objectives/';
export const CREATE_OBJECTIVE = '/api/objectives';
export const UPDATE_OBJECTIVE = '/api/objectives/';
export const DELETE_OBJECTIVE = '/api/objectives/';

/**************************** SUPPLIERS ********************************/

export const GET_ALL_SUPPLIERS = '/api/suppliers';
export const GET_SUPPLIER_BY_ID = '/api/suppliers/';
export const CREATE_SUPPLIER = '/api/suppliers';
export const UPDATE_SUPPLIER = '/api/suppliers/';
export const DELETE_SUPPLIER = '/api/suppliers/';

/**************************** CAMPAIGNS ********************************/

export const GET_ALL_CAMPAIGNS = '/api/campaigns';
export const GET_CAMPAIGN_BY_ID = '/api/campaigns/';
export const CREATE_CAMPAIGN = '/api/campaigns';
export const UPDATE_CAMPAIGN = '/api/campaigns/';
export const DELETE_CAMPAIGN = '/api/campaigns/';

/**************************** REPORTS ********************************/

export const GET_ACTIVITY_REPORT = '/api/reports/activity';